import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type CommentResponse = components['schemas']['Comment'];

type EditCommentRequest = {
  content_object: {
    attachments?: Array<{ id: string }>;
    html_content?: string;
    id: string;
    parent_id: string;
    text_content?: string;
  };
};

export const editComment = async (data: EditCommentRequest) =>
  apiClient.put<CommentResponse, ApiClientResponse<CommentResponse>>(
    routes.contentObjects.comment.edit(data.content_object.id),
    data,
  );
